import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const Topbar = styled.header`
	position: relative;
	grid-column: 1 / -1;
	grid-row: 1;
	min-height: calc(${THEME.topbarHeight} + env(safe-area-inset-top, 0px));
	padding: env(safe-area-inset-top, 0px) 28px 0 2px;
	background:
		linear-gradient(
			104deg,
			transparent 0%,
			transparent 36%,
			rgba(176, 38, 255, 0.1) 49%,
			rgba(255, 77, 242, 0.055) 58%,
			transparent 74%
		),
		${THEME.topbarBg};
	border-bottom: 1px solid ${THEME.line};
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 18px;
	z-index: 8;
	isolation: isolate;

	&::before {
		content: '';
		position: absolute;
		inset: 0 0 auto;
		height: env(safe-area-inset-top, 0px);
		background: ${THEME.topbarBg};
		z-index: -1;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		grid-column: 1;
		grid-row: 1;
		min-height: calc(${THEME.mobileTopbarHeight} + env(safe-area-inset-top, 0px));
		padding: env(safe-area-inset-top, 0px) ${THEME.mobileGutter} 0;
		gap: 8px;
		align-items: center;
	}
`;

export const TopbarLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 26px;
	min-width: 0;
	flex: 1 1 auto;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		flex: 1 1 auto;
		min-width: 0;
		overflow: hidden;
	}
`;

export const Brand = styled.button`
	border: 0;
	background: transparent;
	display: inline-flex;
	align-items: center;
	margin-left: 0;
	color: ${THEME.peach};
	text-decoration: none;
	font-size: clamp(1.35rem, 2vw, 1.7rem);
	font-weight: 800;
	letter-spacing: 0;

	img {
		display: block;
		width: 150px;
		height: 54px;
		object-fit: contain;
		transform: translateX(-31px);
		filter: drop-shadow(0 0 12px rgba(255, 77, 242, 0.68));
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		align-items: center;
		min-width: 0;
		max-width: 100%;

		img {
			width: auto;
			max-width: 88px;
			height: 30px;
			transform: none;
		}
	}
`;

export const Account = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	flex-shrink: 0;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		flex: 0 0 auto;
		gap: 6px;
		align-items: center;
	}
`;

export const TopbarLanguageSlot = styled.div`
	display: none;
	flex-shrink: 0;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		display: flex;
		align-items: center;
		margin-left: 0;
		flex-shrink: 0;

		button {
			width: 34px;
			height: 34px;
			border-radius: 10px;
		}

		svg {
			width: 20px;
			height: 14px;
		}
	}
`;

export const CoinBalance = styled.span`
	color: #fff7ff;
	font-size: 1rem;
	text-shadow: 0 0 12px rgba(255, 77, 242, 0.22);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		font-size: 0.9rem;
		font-weight: 800;
		line-height: 1;
		font-variant-numeric: tabular-nums;
		letter-spacing: -0.01em;
		white-space: nowrap;
		min-width: 0;
	}
`;

export const CoinIcon = styled.img`
	width: 56px;
	height: 56px;
	display: block;
	object-fit: contain;
	filter: drop-shadow(0 0 10px rgba(255, 77, 242, 0.42));

	@media (max-width: ${THEME.mobileBreakpoint}) {
		width: 24px;
		height: 24px;
		flex-shrink: 0;
		filter: drop-shadow(0 0 6px rgba(255, 77, 242, 0.3));
	}
`;

export const CoinMenu = styled.div`
	position: absolute;
	top: calc(100% + 10px);
	right: -18px;
	z-index: 20;
	width: 320px;
	padding: 18px;
	border: 1px solid rgba(255, 255, 255, 0.11);
	border-radius: 14px;
	background:
		radial-gradient(circle at 76% 0%, rgba(255, 211, 107, 0.08), transparent 34%),
		linear-gradient(135deg, rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.025)),
		rgba(8, 7, 10, 0.96);
	box-shadow:
		0 24px 54px rgba(0, 0, 0, 0.52),
		0 0 28px rgba(255, 77, 242, 0.1);
	opacity: 0;
	pointer-events: none;
	transform: translateY(-6px);
	transition: opacity 0.16s ease, transform 0.16s ease;

	&::before {
		content: '';
		position: absolute;
		left: 18px;
		right: 18px;
		bottom: 0;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(255, 211, 107, 0.24), transparent);
	}
`;

export const CoinMenuHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 18px;
`;

export const CoinMenuBalance = styled.span`
	display: flex;
	align-items: center;
	gap: 10px;
	color: #fff7ff;
	font-size: 1.16rem;
	text-shadow: none;

	img {
		width: 34px;
		height: 34px;
		object-fit: contain;
		filter: drop-shadow(0 0 8px rgba(255, 77, 242, 0.34));
	}
`;

export const CoinMenuLabel = styled.span`
	flex: 0 0 auto;
	min-height: 36px;
	display: inline-flex;
	align-items: center;
	border-radius: 10px;
	padding: 0 12px;
	color: rgba(255, 247, 255, 0.82);
	background: rgba(255, 255, 255, 0.07);
	font-size: 0.82rem;
	font-weight: 800;
	text-shadow: none;
`;

export const Coins = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 5px;
	min-height: 56px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		min-height: 34px;
		gap: 5px;
		padding: 4px 8px 4px 10px;
		border-radius: 999px;
		border: 1px solid rgba(255, 214, 255, 0.12);
		background: rgba(255, 255, 255, 0.04);
		flex-shrink: 1;
		min-width: 0;
		max-width: 124px;
	}
	color: ${THEME.gold};
	font-weight: 800;
	text-shadow: 0 0 14px rgba(255, 211, 107, 0.48);
	cursor: pointer;

	&:focus-visible {
		outline: 2px solid rgba(255, 211, 107, 0.72);
		outline-offset: 4px;
		border-radius: 16px;
	}

	@media (min-width: calc(${THEME.mobileBreakpoint} + 1px)) {
		&:hover ${CoinMenu},
		&:focus-within ${CoinMenu} {
			opacity: 1;
			pointer-events: auto;
			transform: translateY(0);
		}
	}
`;

export const AvatarButton = styled.button`
	width: 40px;
	height: 40px;
	border: 0;
	border-radius: 50%;
	display: grid;
	place-items: center;
	flex-shrink: 0;
	background: linear-gradient(135deg, #ffefff, #e6b0ff 46%, ${THEME.pink});
	color: #18071b;
	font-weight: 900;
	cursor: pointer;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		width: 34px;
		height: 34px;
		font-size: 0.82rem;
	}
`;

export const GuestActions = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		gap: 6px;
	}
`;

export const GuestActionButton = styled.button`
	min-height: 38px;
	padding: 0 14px;
	border-radius: 999px;
	border: 1px solid ${(props) => (props.$primary ? 'transparent' : THEME.line)};
	background: ${(props) =>
		props.$primary ? THEME.gradientPrimary : 'rgba(255, 255, 255, 0.05)'};
	color: #fff;
	font-family: ${THEME.fontApp};
	font-size: 0.82rem;
	font-weight: 700;
	cursor: pointer;
	white-space: nowrap;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		min-height: 34px;
		padding: 0 12px;
		font-size: 0.78rem;
	}
`;
